<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle">Present Perfect</h1>
<h3 class="subtitle">Finding God in the Now</h3>
<h3 class="author">Gregory A. Boyd</h3>
<p class="othertext"><b>Bestselling Author of <i>The Myth of a Christian Nation</i></b><br/><br/><br/></p>
<p class="publogo"><img alt="publisher logo" src="images/logo.jpg"/></p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004titlepage.vue?25c62bc4